export const useOnBeforeTaskDrag = gantt => (id, mode) => {
  const task = gantt.getTask(id);
  const isTask = gantt.getTaskByIndex(0).id !== id;
  const canResize = Boolean(isTask && task.startDate && task.endDate);

  return canResize;
};

export default useOnBeforeTaskDrag;
